import { SearchInput } from "@/components/flexkit/SearchInput";
import { WorkflowStatusFilter, WorkflowStatusFilterValue } from "@/components/automations/AutomationStatusFilter";
import {
    AutomationCreatorFilter,
    ALL_CREATORS_VALUE,
    type CreatorFilterValue,
} from "@/components/automations/AutomationCreatorFilter";
import { useEffect, useRef, useState, type FC } from "react";
import { useDebounce } from "use-debounce";
import { type AutomationFilters } from "@/components/automations/automation-filters";

type AutomationListFiltersProps = {
    onFiltersChange: (filters: AutomationFilters) => void;
};

export const AutomationListFilters: FC<AutomationListFiltersProps> = ({ onFiltersChange }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearchQuery] = useDebounce(searchQuery, 300);
    const [statusFilter, setStatusFilter] = useState<WorkflowStatusFilterValue>(WorkflowStatusFilterValue.All);
    const [creatorFilter, setCreatorFilter] = useState<CreatorFilterValue>(ALL_CREATORS_VALUE);

    // Emit filter changes when debounced search changes
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        onFiltersChange({
            search: debouncedSearchQuery.trim(),
            status: statusFilter,
            creator: creatorFilter,
        });
    }, [debouncedSearchQuery, onFiltersChange, statusFilter, creatorFilter]);

    return (
        <div className="flex flex-col gap-2 @md:flex-row @md:items-center">
            <SearchInput
                placeholder="Search automations"
                wrapperClassName="flex-1"
                className="max-w-none"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onClear={() => setSearchQuery("")}
                data-testid="automation-search-input"
            />
            <div className="flex items-stretch gap-2">
                <AutomationCreatorFilter value={creatorFilter} onChange={setCreatorFilter} />
                <WorkflowStatusFilter value={statusFilter} onChange={setStatusFilter} />
            </div>
        </div>
    );
};
